.item {
    width: 100%;
    padding: var(--mantine-spacing-sm) 0;
    border-bottom: 1px solid alpha(var(--dib-ink), 0.2);
}

.item:last-child {
    border-bottom: none;
}

.link {
    display: block;
    width: 100%;
    text-decoration: none;
    color: black;
    cursor: pointer;
    padding: var(--mantine-spacing-xs);
    margin: calc(-1 * var(--mantine-spacing-xs));

    &:hover .chevron {
        opacity: 1;
        transform: translateX(0);
    }
}

.chevron {
    width: 1rem;
    height: 1rem;
    align-self: flex-start;
    margin-top: 4px;
    margin-left: var(--mantine-spacing-xs);
    flex-shrink: 0;
    opacity: 0;
    transform: translateX(-8px);
    transition:
        opacity 0.15s ease,
        transform 0.15s ease;
    color: var(--mantine-color-gray-6);
}

.description {
    color: alpha(var(--mantine-color-dark-5), 0.75);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.indexWrapper {
    margin-left: 3px;
    @container (min-width: $mantine-breakpoint-xs) {
        margin-left: 0;
    }
}

.toolIcon {
    width: 1rem;
    height: 1rem;
    margin-right: var(--mantine-spacing-xs);
    flex-shrink: 0;
    color: black;
    margin-top: 2px;
}

.index {
    font-size: var(--mantine-font-size-xs);
    color: white;

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-sm);
    }
}

.content {
    font-size: var(--mantine-font-size-sm);
    margin-left: 2px;
    flex: 1;
    min-width: 0;
    @container (min-width: $mantine-breakpoint-xs) {
        margin-left: 0px;
    }
    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-sm);
    }
}

.feedbackContent {
    color: red;
}
